export interface CollectablePage<T> {
	documents: T[];
	totalPage: number;
}

/**
 * Every document of a paginated search: page 1 first (it tells how many pages exist), then the remaining pages
 * at once. A search that stopped at page 1 would silently drop whatever did not fit.
 */
export async function collectAllPages<T>(fetchPage: (page: number) => Promise<CollectablePage<T>>): Promise<T[]> {
	const first = await fetchPage(1);
	const otherPages = Array.from({ length: Math.max(0, first.totalPage - 1) }, (_, index) => index + 2);
	const rest = await Promise.all(otherPages.map((page) => fetchPage(page)));
	return [first, ...rest].flatMap((page) => page.documents);
}
